import React, { useState } from 'react';
import { HiOutlineLightBulb } from 'react-icons/hi';
import InfoPOP from './common/InfoPop';

type Props = {
    title: string;
    infoText: 'AccreditedInvestor' | 'kycInfo' | 'NDA';
};

const OnboardingHeading: React.FC<Props> = ({ title, infoText }) => {
    const [open, setOpen] = useState(false);
    const infoTextType = {
        AccreditedInvestor:
            'As Helicap is licensed to deal with accredited and institutional clients, we are required to independently assess the AI eligibility of our clients.',
        kycInfo: `<div>
            <p>As Helicap is regulated by the Monetary Authority of Singapore, KYC checks are required to be completed for the clients of Helicap.</p>
        </div>`,
        NDA: 'A Non-disclosure Agreement (NDA) protects the confidential information of the companies of the deals. An agreement allows us to share more information with you for better decision making.',
    };
    return (
        <>
            <InfoPOP
                open={open}
                setOpen={setOpen}
                icon={<HiOutlineLightBulb size={'1.9rem'} color="#26AE60" />}
                text={infoTextType[infoText]}
            />
            <div className="flex justify-between items-center flex-col md:flex-row">
                <p className="page_title_onboarding w-full">{title}</p>
                <div className="flex items-center cursor-pointer justify-end w-full" onClick={() => setOpen(true)}>
                    {' '}
                    <HiOutlineLightBulb size={'1.25rem'} color="#26AE60" />{' '}
                    <p className="right-text text-[#142C53] ml-1">Why are we requesting this?</p>
                </div>
            </div>
        </>
    );
};
export default OnboardingHeading;
